import { Disabler } from "./disabler";
import { SelectableBox } from "./selectable_box";

export function SimpleSelectableBoxItem(props: {
	header: string | JSX.Element;
	description: string | JSX.Element;
	disabled?: boolean;
	icon?: JSX.Element;
	bgColor: "semidark" | "dark";
	onClick: () => void;
}) {
	return (
		<Disabler disabled={props.disabled}>
			<SelectableBox
				onClick={() => {
					if (props.disabled) {
						return;
					}
					props.onClick();
				}}
				bgColor={props.bgColor}
			>
				<div className="flex w-full items-center gap-4">
					{props.icon && <div className="text-3xl">{props.icon}</div>}
					<div className="flex w-11/12 flex-col text-content-primary-darker">
						<div className="font-bold text-content-primary">
							{props.header}
						</div>
						<div>{props.description}</div>
					</div>
					<div className="ml-auto self-center text-content-primary">
						{!props.disabled ? (
							<i className="fas fa-chevron-right "></i>
						) : (
							<i className="fas fa-lock"></i>
						)}
					</div>
				</div>
			</SelectableBox>
		</Disabler>
	);
}
